/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Level_Standings_AdjustmentInputs */



/**
* | output |
* | --- |
* | "Standings Adjustment" |
*
* @param {Sanction_Level_Standings_AdjustmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_level_standings_adjustment = /** @type {((inputs?: Sanction_Level_Standings_AdjustmentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Level_Standings_AdjustmentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajustement de Classement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajuste de Clasificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ajuste de Classificação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiustamento di Classifica")
	return /** @type {LocalizedString} */ ("Standings Adjustment")
});